// Common
export const AddToasts = 'ADD_TOASTS';
export const RemoveToasts = 'REMOVE_TOASTS';
export const ShowLoader = 'SHOW_LOADER';
export const SetError = 'SET_ERROR';
export const ModalError = 'MODAL_ERROR';

// Auth
export const LoginType = 'LOGIN';
export const LogoutType = 'LOGOUT';
export const LoggedInUser = 'LOGGED_IN_USER'

// Admin Dashboard
export const GetUsers = 'GET_USERS';
export const GetCustomers = 'GET_CUSTOMERS';
export const UpdateSearchParams = 'UPDATE_SEARCH_PARAMS';
export const ResetAdminDashboard = 'RESET_ADMIN_DASHBOARD';

// Management User/Customer
export const GetUsersList = 'GET_USERS_LIST';
export const GetUser = 'GET_USER';
export const UpdateUserField = 'UPDATE_USER_FIELD';

export const GetCustomersList = 'GET_CUSTOMERS_LIST';
export const GetCustomer = 'GET_CUSTOMER';
export const UpdateCustomerField = 'UPDATE_CUSTOMER_FIELD';
export const UpdateManageSearchParams = 'UPDATE__MANAGE_SEARCH_PARAMS';
export const ResetManageUser = 'RESET_MANAGE_USER';
export const UpdateCountryList = 'UPDATE_COUNTRY_LIST';

// Main Dashboard
export const GetProductTypes = 'GET_PRODUCT_TYPES';
export const GetProductReturns = 'GET_PRODUCT_RETURNS';
export const UpdateProductReturns = 'UPDATE_PRODUCT_RETURNS';
export const UpdateProductReturnType = 'UPDATE_PRODUCT_RETURN_TYPE';
export const ResetMainDashboard = 'RESET_MAIN_DASHBOARD';
export const UpdateProductReturnById = 'UPDATE_PRODUCT_RETURN_BY_ID'
// Application Paramters
export const GetAppParameter = 'GET_APP_PARAMETER';
export const UpdateAppParameter = 'UPDATE_APP_PARAMETER';
export const ResetSiteConfiguration = 'RESET_SITE_CONFIGURATION';

// Return Note
export const GetReturnNote = 'GET_RETURN_NOTE';
export const GetCustomersByName = 'GET_CUSTOMER_BY_NAME';
export const UpdateSearchedName = 'UPDATE_SEARCHED_NAME';
export const SelectCustomer = 'SELECT_CUSTOMER';
export const SaveReturnNote = 'SAVE_RETURN_NOTE';
export const UpdateValidationObject = 'UPDATE_VALIDATION_OBJECT';
export const ToggleShowCustomerModal = 'TOGGLE_SHOW_CUSTOMER MODAL';
export const UpdateComment = 'UPDATE_COMMENT';
export const DeleteComment = 'DELETE_COMMENT';

// report
export const GetReportsType = 'GET_REPORTS_TYPE';
export const GetReportsProductsType = 'GET_REPORTS_PRODUCTS_TYPE';
export const GetReportDetail = 'GET_REPORT_DETAIL';
export const UpdateReportForm = 'UPDATE_REPORT_FORM';
export const UpdateReportValidationObject = 'UPDATE_REPORT_VALIDATION_OBJECT';
export const UpdateReportIsFetchingState = 'UPDATE_REPORT_IS_FETCHING_STATE';
export const UpdateFinalReportFormData = 'UPDATE_FINAL_REPORT_DATA';
export const UpdateIsExportReport = 'UPDATE_IS_EXPORT_REPORT';
export const ResetReportFilter = 'RESET_REPORT_FILTER';
